export default "<mp-app [app]=\"appInfo\"></mp-app>\n"